/**
 * ScoringEvent
 */
window.ScoringEvent = {

	callbacks : {},

	settings: {
		route: 'scoringEvent',
		formName: 'scoringEventForm',
		formScoreName: 'scoringEventHasUserForm',
		filterName: 'scoringEventFilterForm',
		popupWidth: 800
	},

	translations: {
		add: Loc.g("Ajout d'un événement"),
		addScore: Loc.g("Ajouter du score"),
		update: Loc.g("Modification d'un événement"),
		save: Loc.g("Enregistrer"),
		valid: Loc.g("Valider"),
		loading: Loc.g('Chargement'),
		cancel: Loc.g("Annuler"),
		close: Loc.g("Fermer"),
		history: Loc.g("Détail du scoring"),
		delete: Loc.g("Suppression d'un événement"),
		confirmDelete: Loc.g("Valider pour supprimer l'événement."),
	},

	selectors: {
		body: 'body',
		form: '#scoringEventForm',
		formScore: '#scoringEventHasUserForm',
		popup: '#popupWindow',
		tips: '.status [tip_relid]',
		selectType: '.eventstypesselect',
		wrapperIdent: '.score-ident',
		buttonWrapper: '.ui-dialog-buttonpane',
		button: 'span.ui-button-text'
	},

	add: function(id)
	{
		var self = this;
		var options = {
			title	: self.translations.add,
			buttons	: [
                {text : self.translations.cancel, click: function() {$(this).dialog("close");} },
                {
					text :	self.translations.save,
					click :	function()
					{
						var buttons	 = $(this).parent().find(self.selectors.buttonWrapper);
						var register = buttons.find('button[type=button]').find(self.selectors.button).first();

						register.text(self.translations.loading+' ...');
						register.attr('disabled', 'disabled');

						if ($(self.selectors.body).data('addFormDisabled') === undefined) {
							$(self.selectors.body).data('addFormDisabled', false);
						}

						if (!$(self.selectors.body).data('addFormDisabled')) {
							$(self.selectors.body).data('addFormDisabled', true);
							$(self.selectors.form).submit();

							setTimeout(function()
							{
								var buttons	 = $(self.selectors.popup).parent().find(self.selectors.buttonWrapper);
								var register = buttons.find('button[type=button]').find(self.selectors.button).first();

								register.text(self.translations.save);
								$(self.selectors.body).data('addFormDisabled', false);
							}, 2000);
						}
					}
				}
			],
			width: self.settings.popupWidth,
			callback : function() {
				self.initAddForm("N");
				Qtip.init();
			}
		};

		MyWindow.load(self.settings.route, {action:"addForm", sid: id}, options);
	},

	initAddForm: function(edit)
	{
		edit = (edit === undefined) ? "N" : edit;

		var self = this;
		var options = {
			dataType : "json",
			data : {
				action	: 'record',
				context : ''
			},
			success	: function(data) {
				self.recordCallback(data);
			}
		};

		MyForm.prepare(self.settings.formName, self.settings.route+"&", options, true);
		MyFacture.customForm();
		self.toggleIdent($(self.selectors.selectType));
	},

	processForm: function(data)
	{
		var self = this;
		MyForm.processJson(data, self.settings.formName);
	},

	edit: function(id, context)
	{
		var self = this;
		var options = {
			title	: self.translations.update,
			buttons	: [
                {text : self.translations.cancel, click : function() { $(this).dialog("close"); }},
                {text : self.translations.save, click : function() { $(self.selectors.form).submit(); }}
			],
			width: self.settings.popupWidth,
			callback : function() {
				self.prepareForm(context);
			}
		};
		MyWindow.load(self.settings.route, {action: "editForm", sid: id}, options);
	},

	prepareForm: function(context)
	{
		var self = this;
		var options = {
			data : {
				action	: 'record',
				context : context,
			},
			success: function(data) {
				self.recordCallback(data);
			},
			dataType: "json"
		};

		MyForm.prepare(self.settings.formName, self.settings.route, options, true);
		MyFacture.customForm();
		self.toggleIdent($(self.selectors.selectType));
	},

	recordCallback: function(data)
	{
		var self = this;
		var isOk = MyForm.processJson(data, self.settings.formName);

		if (isOk) {
			Utils.reload();
		}
	},

	prepareFilterForm: function()
	{
		var self = this;
		var options = {success: function(data){ self.processFilterForm(data); }, dataType:"json"};

		MyForm.prepare(self.settings.filterName, self.settings.route+"&action=updateListing", options);
	},

	initTips: function()
	{
		var self = this;
		var link = [ 'left','right','top','bottom' ];

		$(self.selectors.tips).not('.initialized').each(function() {

			$(this).addClass('initialized');


			var relatedId	= $(this).attr('tip_relid');
			var type		= $(this).attr('tip_type');
			var relatedType = $(this).attr('tip_reltype');
			var defaultText = $(this).attr('tip_txt');


			$(this).qtip({
				style : {
					classes : 'custom-qtip rich-qtip',
					def		: false,
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center',
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout', 
					fixed: true,
					delay: 100
				},
				content:{
					text : "<div style='width:100px>'<i class='fa-20 fa fa-circle-o-notch fa-spin'></i></div>",
					ajax : {
						url	: './?_f='+self.settings.route,
						type: 'GET',
						data: {
							action		: 'poptasks', 
							relatedid	: relatedId, 
							relatedtype : relatedType
						},
						once: true
					}
				}
			});

		});
	},

	processFilterForm: function(data)
	{
		Listing.refresh("scoringEventListing", data, data.scoringEvent_metadatas);
		this.initTips();
		Third.qtipInit();
	},

	buildPagenum: function(pagenum, nbpage)
	{

	},

	confirmDeletion: function(sid)
	{
		var self = this;
		var options = {
			resizable	: false,
			noclose		: true,
			type		: "warning",
			title		: self.translations.delete,
			buttons		: [
                {text : self.translations.cancel, click : function() { $(this).dialog("close"); } },
                {text :
				self.translations.valid,
					click : function() {
						self.deleteIt(sid);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(self.translations.confirmDelete, options);
	},

	deleteIt: function(sid)
	{
		var self = this;
		var datas = {'action': "delete", 'sid': sid};
		MyFacture.post(self.settings.route, datas, function(data) { self.deleteItCallback(data); }, "json");
		return true;
	},

	deleteItCallback: function(data)
	{
		Utils.reload();
	},

	toggleIdent: function(select)
	{
		var self = this;
		var value = select.val();
		
		if ('action' === value) {
			$(self.selectors.wrapperIdent).show();
		} else {
			$(self.selectors.wrapperIdent).hide();
		}
		
	},
	
	switchEvent: function (select){
		
		var self = this;
		var value = select.val();
		
		$(self.selectors.form).find('.eventstypesselect').hide();
		$(self.selectors.form).find('#sehs_type_'+value).show();
		
		if (value === "tracking"){
			$(self.selectors.form).find('.urls').show();
			self.toggleIdent($(self.selectors.selectType));
		} else {
			$(self.selectors.form).find('.urls').hide();
			$(self.selectors.wrapperIdent).hide();
		}
		
	},

	addUrl: function()
	{
		var self = this;
		var row = $('.list li.first').clone();
		// Nettoyage de l'éléement cloné
		row.removeClass('first').find('input').removeClass('ui-state-error').val('');
		// On ajoute l'élément cloné dans le container
		row.appendTo('.list');
		// Mise à jour des index
		self.updateIndex($('.list li'));
	},

	deleteUrl: function(row)
	{
		var self = this;
		row.closest('li').remove();
		// Mise à jour des index
		self.updateIndex(row.parents('.list').find('li'));
	},

	updateIndex: function(container)
	{
		var self = this;
		container.each(function(i) {
			$(this).find('label').attr('for', $(this).find('label').attr('for').replace(/\d+/, i));
			$(this).find('input').attr('id', $(this).find('input').attr('id').replace(/\d+/, i));
		})
	},

	addScore: function(thirdid, tpcid, redirect) {
		var self = this;
		var options = {
            dialogClass: "white",
			title	: self.translations.addScore,
			buttons	: [
                {text : self.translations.cancel, click: function() {$(this).dialog("close");} },
                {
					text :	self.translations.save,
					click :	function()
					{
						var buttons	 = $(this).parent().find(self.selectors.buttonWrapper);
						var register = buttons.find('button[type=button]').find(self.selectors.button).first();

						register.text(self.translations.loading+' ...');
						register.attr('disabled', 'disabled');

						if ($(self.selectors.body).data('addFormDisabled') === undefined) {
							$(self.selectors.body).data('addFormDisabled', false);
						}


						if (!$(self.selectors.body).data('addFormDisabled')) {
							$(self.selectors.body).data('addFormDisabled', true);
							$(self.selectors.formScore).submit();

							setTimeout(function()
							{
								var buttons	 = $(self.selectors.popup).parent().find(self.selectors.buttonWrapper);
								var register = buttons.find('button[type=button]').find(self.selectors.button).first();

								register.text(self.translations.save);
								$(self.selectors.body).data('addFormDisabled', false);
							}, 2000);
						}
					}
				}
			],
			width: self.settings.popupWidth,
			callback : function() {
				self.initAddScoreForm(thirdid, tpcid, redirect);
				Qtip.init();
			}
		};

		MyWindow.load(self.settings.route, {action:"addScoreForm"}, options);
	},

	initAddScoreForm: function(thirdid, tpcid, redirect)
	{
		var self = this;
		var options = {
			dataType : "json",
			data : {
				action	: 'recordScore',
				context : '',
				thirdid: thirdid,
				tpcid: tpcid,
				redirect: redirect
			},
			success	: function(data) {
				self.recordCallback(data);
			}
		};

		MyForm.prepare(self.settings.formScoreName, self.settings.route+"&", options, true);
		MyFacture.customForm();
	},

	history: function(corpid, thirdid) {
		var self = this;
		var options = {
            dialogClass: "white",
			title	: self.translations.history,
			buttons	: [
				{
					text	: self.translations.close,
					click	: function() {
						$(this).dialog("close");
					}
				}
			],
			width: self.settings.popupWidth
		};

		MyWindow.load(self.settings.route, {action:"history", corpid: corpid, thirdid: thirdid}, options);
	},

	historyLoadMore: function(corpid, thirdid) {
		var self    = this;
		var page   = parseInt($('#historyScore .load-more a').attr('page'));
		var container	= $("#scoringListContainer");
                
		var params = {
			action	: "historyLoadMore",
			corpid	: corpid,
			thirdid	: thirdid,
			page	: page
		};
                MyFacture.post("scoringEvent", params, function(data){
                    container.append(data.html);
                    $('#historyScore .load-more a').attr('page', data.page);
                        if (data.noMoreElement === 'Y'){
		 		$('#btnLoadMore').remove();
		 	} else {
		 		$('#btnLoadMore').removeClass('wait');
		 	}
             }, "json");
	}
};